import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TitleService } from '../../../services/title/title.service';
import { environment } from '../../../../environments/environment';
import { AlertService, AlertStyleEnum } from '../../../services/alert/alert.service';
import { changeState, growTextAnimation } from '../../../helpers/animation';
import { CampaignService } from '../services/campaign.service';
import {
    FilteredFaceDetailsParams,
    FaceService,
    FilteredGroupFaceDetailsResult,
    FilteredFaceDetailsResult,
} from '../services/face.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuContextService } from '../../layout/services/menu-context.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SpotService } from '../../spots/services/spot.service';
import { UserTagsService } from '../../../services/user/userTags.service';
import { MenuExpandContextService } from '../../layout/services/menu-expand-context.service';
import { Crisp } from 'crisp-sdk-web';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { HttpErrorResponse } from '@angular/common/http';

class ElementRef<T = any> {
    constructor(nativeElement: T) {
        this.nativeElement = nativeElement;
    }
    nativeElement: T;
}

@Component({
    selector: 'wncm-choose-screens',
    templateUrl: './choose-screen.component.html',
    styleUrls: ['./choose-screen.component.scss'],
    animations: [growTextAnimation],
})
export class ChooseScreensComponent implements OnInit {

    @ViewChild('infiniteScrollParentElem')
    public infiniteScrollParentElem: ElementRef;
    public id$ = new BehaviorSubject<any>(null);
    protected diffusionId$ = new BehaviorSubject<any>(null);
    public organizationId$ = new BehaviorSubject<any>(null);
    public spotDuration: number;

    /**
     * Est en rélaité le diffusionId
     */
    public diffusionId: number;
    public faceId: number;
    public status = false;

    public baseUrl: string;

    public editMode = false;

    public orgLocations: FilteredGroupFaceDetailsResult[] = [];

    public organizationId: number;

    public fromPark = false;

    public cState = changeState;
    public animationState = 'initial';
    public windowWidth;
    window: Window;
    public total$: any;

    public faceSelected: number[] = [];

    public nextText = 'Choisir un écran';
    public nextTextValid: string;
    public nextIconText = 'error';

    public loader = true;
    public shutterName = 'Sélectionner vos écrans';

    public isDeviceisDesktop = false;

    public spotId: number;
    public spotName: string;

    // MARK: CONSTRUCTOR
    constructor(
        private readonly campaignService: CampaignService,
        public faceService: FaceService,
        public faceFilter: FilteredFaceDetailsParams,
        protected route: ActivatedRoute,
        private readonly router: Router,
        private readonly dialog: MatDialog,
        private readonly title$: TitleService,
        public alert: AlertService,
        public menuContext$: MenuContextService,
        public menuExtend$: MenuExpandContextService,
        private readonly deviceService: DeviceDetectorService,
        public spotService: SpotService,
        private readonly waiting$: WaitingService
    ) {
        this.route.queryParams.subscribe((params) => {
            this.id$.next(params.organizationId);
        });

        route.paramMap.subscribe((paramsMap: ParamMap) => {
            this.diffusionId$.next(paramsMap.get('diffusionId'));
        });

        this.baseUrl = environment.apiBaseUrl;

        this.window = <Window>window;
    }

    openModal(templateRef: any) {
        this.dialog.open(templateRef, {
            width: '250px',
        });
    }

    public changeState(): void {
        this.cState(this.animationState);
    }

    ngOnInit() {
        if (window.innerWidth <= 900) {
            this.isDeviceisDesktop = false;
        } else {
            this.isDeviceisDesktop = true;
        }
        if (!Crisp.isCrispInjected()) {
            Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4');
            if(!this.isDeviceisDesktop){
                Crisp.chat.hide();
            }
        } else {
            Crisp.chat.show();
            if(!this.isDeviceisDesktop){
                Crisp.chat.hide();
            }
        }
        setTimeout(() => {
            this.title$.next('Choix des faces');
        }, 0);

        const isDesktopDevice = this.deviceService.isDesktop();
        this.windowWidth = window.innerWidth;

        this.changeState();
        this.id$.subscribe((id) => {
            this.organizationId = id;

            // Update du customer context en cas de rafraichissement de la page en pleine commande
        });

        this.diffusionId$.subscribe((diffusionId: number) => {
            this.diffusionId = diffusionId;
        });

        //Récupération des paramètres dans l'URL
        this.route.queryParams.subscribe((p: any) => {
            if (p.spotId != null) {
                this.spotService.getSpotName(p.spotId).subscribe((res) => {
                    this.spotName = res.name;
                });
            }
        });

        this.editMode = JSON.parse(this.route.snapshot.queryParams.editMode);

        if (this.route.snapshot.queryParams.faceId != null) {
            this.faceId = parseInt(this.route.snapshot.queryParams.faceId);
        }
        if (this.route.snapshot.queryParams.fromPark != null) {
            this.fromPark = this.route.snapshot.queryParams.fromPark;
        }
        if (this.route.snapshot.queryParams.campaignId != null) {
            this.diffusionId = this.route.snapshot.queryParams.campaignId;

            this.resetFilter();
            this.faceFilter.diffusionId = this.diffusionId;
        }

        this.resetFilter();

        this.loadScreenData();
        this.callbackUntilScrollable();

        setTimeout(() => {
            this.title$.next('Choix des écrans');
        }, 0);
    }

    resetFilter() {
        this.faceFilter = new FilteredFaceDetailsParams();
        this.faceFilter.page = 0;
        this.faceFilter.pageSize = 20;
        const map = UserTagsService.getTagsSelection(this.shutterName);
        this.faceFilter.tags = UserTagsService.getSelectedTags(map);
    }

    next() {
        if (this.faceSelected.length !== 0) {
            this.campaignService
                .setFaces(this.diffusionId, this.faceSelected)
                .subscribe(() => {
                    // Le client valide directement sa commande puisqu'il a déjà sélectionné un spot
                    this.alert.show({
                        message: this.editMode
                            ? 'Votre campagne a bien été modifiée !'
                            : 'Votre campagne a bien été créée !',
                        duration: 5000,
                    });
                    this.redirectToMainPage();
                });
        } else {
            this.alert.show({
                message: 'Sélectionner au moins un écran pour continuer !',
                duration: 5000,
            }, AlertStyleEnum.Warning);
        }
    }

    goBack() {
        window.history.go(-1);
    }

    getTagName(tagId: number) {
        return UserTagsService.getTagName(tagId);
    }

    public reloadFilter(filterParams: FilteredFaceDetailsParams) {
        this.faceFilter = filterParams;
        this.orgLocations = [];
        this.loadScreenData();
        this.callbackUntilScrollable();
    }

    /**
     * Charge la liste des écrans
     *
     * `getFilteredFaceDetails`
     */
    private loadScreenData() {
        this.faceFilter.diffusionId = this.diffusionId;
        this.loader = true;
        const waitingId: string = this.waiting$.start();
        this.faceService
            .getFilteredFaceDetails(this.faceFilter)
            .subscribe({
                next: (item) => {
                    this.waiting$.end(waitingId);

                    this.total$ = item.ret.total;

                    item.ret.items.forEach((of: FilteredGroupFaceDetailsResult) => {
                        const index: number = this.orgLocations.findIndex(
                            (orgLoc) => orgLoc.k === of.k
                        );
                        if (index === -1) this.orgLocations.push(of);
                        else
                            this.orgLocations[index].l = this.orgLocations[
                                index
                            ].l.concat(of.l);
                    });

                    this.faceSelected = item.sf;

                    if (this.faceId != null) {
                        this.faceSelected.push(this.faceId);

                        this.nextTextValid = `Valider les écrans  (${this.faceSelected.length})`;

                    }
                    this.loader = false;
                },
                error: (err: HttpErrorResponse) => {
                    this.waiting$.end(waitingId);

                    console.error(err);

                    this.alert.show({
                        message: "Erreur lors du chargement des écrans",
                        duration: 1700
                    }, AlertStyleEnum.Error);


                    this.loader = false;
                }
            });
    }

    onResize(event) {
        event.preventDefault();
    }

    onScroll() {

        let total = this.total$;
        if (total / this.faceFilter.pageSize > this.faceFilter.page + 1) {
            this.faceFilter.page = this.faceFilter.page + 1;
            this.loadScreenData();
            this.callbackUntilScrollable();
        }
    }

    private callbackUntilScrollable() {
        window.setTimeout(() => {
            if (this.infiniteScrollParentElem) {
                if (
                    this.infiniteScrollParentElem.nativeElement.clientHeight >
                    this.infiniteScrollParentElem.nativeElement.scrollHeight -
                    15
                ) {
                    this.onScroll();
                }
            } else {
                this.callbackUntilScrollable();
            }
        }, 500);
    }

    tagIsSelected(tag) {
        return UserTagsService.tagIsInSelection(this.shutterName, tag);
    }

    getAspectRatio(pixelWidth: number, pixelHeight: number): string {
        const gcd = (a: number, b: number): number => {
            return b === 0 ? a : gcd(b, a % b);
        };
        const divisor = gcd(pixelWidth, pixelHeight);
        const widthRatio = pixelWidth / divisor;
        const heightRatio = pixelHeight / divisor;
        return `${widthRatio}:${heightRatio}`;
    }

    processFace(face: FilteredFaceDetailsResult) {
        if (face.e !== true) {
            return;
        }


        const index = this.faceSelected.findIndex((tag) => tag === face.i);
        if (index === -1) {
            this.faceSelected.push(face.i);
            this.nextTextValid =
                'Continuer avec ' + this.faceSelected.length + ' écrans';
        } else {
            this.faceSelected.splice(index, 1);
            if (this.faceSelected?.length === 0) this.nextTextValid = null;
            else
                this.nextTextValid =
                    'Continuer avec ' + this.faceSelected.length + ' écrans';
        }
    }

    toggleCheckFaces($event) {
        if ($event.checked) {
            this.checkAllFaces();
        } else {
            this.uncheckAllFaces();
        }

    }

    checkAllFaces() {
        this.orgLocations.forEach(orgL => {
            orgL.l.forEach(face => {
                if (this.faceSelected.findIndex((faceId) => faceId === face.i) === -1 && face.e) {
                    this.faceSelected.push(face.i);
                }
            });

        });

        this.nextTextValid = `Valider les écrans  (${this.faceSelected.length})`;
    }

    uncheckAllFaces() {
        this.orgLocations.forEach(orgL => {
            orgL.l.forEach(face => {
                const index = this.faceSelected.findIndex((faceId) => faceId === face.i)
                if (index !== -1) {
                    this.faceSelected.splice(index, 1);
                }
            });

        });
        this.nextTextValid = this.faceSelected?.length === 0 ? null : `Valider les écrans  (${this.faceSelected.length})`;
    }

    faceIsSelected(tagId: number) {
        return this.faceSelected.findIndex((tag) => tag === tagId) !== -1;
    }

    /**
     * getFaceBgUrl
     */
    public getFaceBgUrl(face: FilteredFaceDetailsResult): string {
        const encodedFilename = encodeURIComponent(face.t);
        const baseUrl = `${this.baseUrl}/file/getFile`;
        const fullUrl = `${baseUrl}/${encodedFilename}`;
        const encodedUrl = fullUrl.replace(/'/g, "%27");
        const finalUrl = `background-image: url('${encodedUrl}/${face.i});`;
        return finalUrl;
    }

    private redirectToMainPage() {
        const endRedirect: string = localStorage.getItem("EndRedirection") ?? 'park';

        localStorage.removeItem("EndRedirection");
        this.router.navigateByUrl(endRedirect);
    }

    scrollParkContainer(scroll) {

        // if (!this.isMobile) {
        if (scroll.target.scrollTop > 200) {
            this.hideLayout();
            return;
        }



        if (scroll.target.scrollTop < 120) {
            this.showLayout();
            return;
        }
        // }

    }

    private hideLayout() {
        // Hide Layout
        document.getElementById('mainToolbar').style.animationName = "toolbarAnimHide";
        document.getElementById('mobileFilter').style.animationName = "toolbarAnimHide";

        setTimeout(() => {

            document.getElementById('mainToolbar').style.display = 'none';
            document.getElementById('mainToolbar').style.visibility = 'hidden';
            // document.getElementById('container').style.top = '0px';

            if (!this.isDeviceisDesktop) {
                document.getElementById('mobileFilter').style.top = "0px";
            }
        }, 0);
    }

    private showLayout() {
        // Show Layout
        document.getElementById('mainToolbar').style.animationName = "toolbarAnimShow";
        document.getElementById('mobileFilter').style.animationName = "toolbarAnimShow";
        setTimeout(() => {

            document.getElementById('mainToolbar').style.display = 'flex';
            document.getElementById('mainToolbar').style.visibility = 'visible';
            // document.getElementById('container').style.top = '80px';

            if (!this.isDeviceisDesktop) {
                document.getElementById('mobileFilter').style.top = "80px";
            }
        }, 0);
    }

    getTagIcon(tagId: number) {
        return UserTagsService.getTagIcon(tagId);
    }
}
